module.exports = __webpack_public_path__ + "static/media/1334.ffbe7645.pdf";